import GlobalTokens from '@sainsburys-tech/design-tokens/dist/global/json/tokens.json';
import ColourBlock from '@components/colour-block';
import * as React from 'react';
export default {
  GlobalTokens,
  ColourBlock,
  React
};